import useAPI from "./useAPI";

export default function useRwas() {
  const api = useAPI();

  const getAllRWAs = async (companyId) => {
    return await api.getAllRWAs(companyId);
  };

  const createRWA = async (companyId, rwaData) => {
    return await api.createRWA(companyId, rwaData);
  };

  const deleteRWA = async (companyId, rwaId) => {
    return await api.deleteRWA(companyId, rwaId);
  };

  const updateRwa = async (companyId, rwaId, rwaData) => {
    return await api.updateRwa(companyId, rwaId, rwaData);
  };

  const getRwaDetails = async (companyId, rwaId) => {
    return await api.getRwaDetails(companyId, rwaId);
  };

  const updateRwaDataPage = async (companyId, rwaId, data) => {
    return await api.upsertRwaDataPage(companyId, rwaId, data);
  };

  const createRwaNft = async (companyId, rwaId, nftData) => {
    return await api.createRwaNft(companyId, rwaId, nftData);
  };

  const getRwaNfts = async (companyId, rwaId) => {
    return await api.getRwaNfts(companyId, rwaId);
  };

  const updateRwaNfts = async (companyId, rwaId, nftId, nftData) => {
    return await api.updateRwaNft(companyId, rwaId, nftId, nftData);
  };

  const deleteRwaNft = async (companyId, rwaId, nftId) => {
    return await api.deleteRwaNft(companyId, rwaId, nftId);
  };

  return {
    getAllRWAs,
    createRWA,
    deleteRWA,
    updateRwa,
    getRwaDetails,
    updateRwaDataPage,
    createRwaNft,
    getRwaNfts,
    updateRwaNfts,
    deleteRwaNft,
  };
}